import { render } from "./ModulesSingleScreen.vue?vue&type=template&id=13d42709"
import script from "./ModulesSingleScreen.vue?vue&type=script&lang=js"
export * from "./ModulesSingleScreen.vue?vue&type=script&lang=js"

import "./ModulesSingleScreen.vue?vue&type=style&index=0&id=13d42709&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__